export class ForbiddenError extends Error {
  constructor({ message = "Access Forbidden", status = 403 }) {
    super(JSON.stringify({ message, status }));
    this.name = "ForbiddenError";
    this.status = status;
  }
}
